import { StyledChartLoading } from './skill-matrix-graphic.styles';
export const SkillMatrixFallback = ({
  isLoadingChart,
  fallbackText,
  isDashboard
}: {
  isLoadingChart: boolean;
  isDashboard?: boolean;
  fallbackText: string;
}) => isLoadingChart ? <StyledChartLoading $isDashboard={isDashboard} aria-label="chart loading..." aria-hidden="false" /> : <p>{fallbackText}</p>;